import { motion } from 'motion/react';

export const Loader = () => {
    return (
        <div className="flex flex-col items-center justify-center p-12 w-full h-[60vh] min-h-75 text-slate-400 dark:text-slate-500">
            <div className="relative w-24 h-24 flex items-center justify-center">
                <svg viewBox="0 0 100 120" className="w-full h-full drop-shadow-lg" fill="none" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round">
                    {/* Background shield (faint) */}
                    <path 
                        d="M50 5 L10 25 L10 65 C10 95 50 115 50 115 C50 115 90 95 90 65 L90 25 Z" 
                        className="stroke-slate-200 dark:stroke-slate-800" 
                    />
                    
                    {/* Animated drawing shield */}
                    <motion.path 
                        d="M50 5 L10 25 L10 65 C10 95 50 115 50 115 C50 115 90 95 90 65 L90 25 Z" 
                        className="stroke-orange-500"
                        initial={{ pathLength: 0, opacity: 0 }}
                        animate={{ pathLength: 1, opacity: 1 }}
                        transition={{ duration: 2, repeat: Infinity, ease: "easeInOut", repeatType: "reverse" }}
                    />

                    {/* Checkmark inside */}
                    <motion.path
                        d="M35 60 L45 70 L65 45"
                        className="stroke-orange-500"
                        initial={{ pathLength: 0, opacity: 0 }}
                        animate={{ pathLength: 1, opacity: 1 }}
                        transition={{ duration: 1.5, delay: 0.5, repeat: Infinity, ease: "easeInOut", repeatType: "reverse" }}
                    />
                </svg>
            </div>
        </div>
    );
};
